// extracted by mini-css-extract-plugin
export var checkIcon = "_8-2";
export var heading = "_8-1";
export var panel = "_8-0";